import { render } from "./NetworkInfraPenTestForm.vue?vue&type=template&id=00b8cdae"
import script from "./NetworkInfraPenTestForm.vue?vue&type=script&lang=js"
export * from "./NetworkInfraPenTestForm.vue?vue&type=script&lang=js"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__